/** Перенос `domain/models/public_tablet.dart`. */

import { z } from 'zod';

/** Планшет из публичного списка сервера (`GET /api/v1/tablets/public`). */
export interface PublicTablet {
  /** Последняя часть адреса: `https://lp.hron.uz/{slug}`. */
  readonly slug: string;

  readonly name: string;
}

export const publicTabletSchema = z.object({
  slug: z.string(),
  name: z.string(),
});

export function publicTabletFromJson(json: unknown): PublicTablet {
  return publicTabletSchema.parse(json);
}
